module.exports = __webpack_public_path__ + "static/media/monkey.f4ea1bbc.svg";